// @flow
import React, { useCallback } from 'react'

import makeStyles from '@material-ui/styles/makeStyles'

import emptylawyer from '../../assets/images/emptylawyer.png'
import loadingMain from '../../assets/images/loadingMain.gif'
import { useGlobalState } from '../../store'

const useStyles = makeStyles({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  imageLoader: {
    maxHeight: 150,
  },
})

type Props = {
  open?: boolean,
  loaderType?: string,
  description?: string,
}

const MainLoader = ({
  open = false,
  loaderType = 'loader',
  description = '',
  style = {},
}: Props) => {
  const [theme] = useGlobalState('theme')

  const classes = useStyles()

  const getImages = useCallback(
    (loaderType): string => {
      if (!!theme.loaded) {
        if (loaderType === 'offLine') {
          return theme.images.loadingSecondary
        } else {
          return theme.images.loadingMain
        }
      } else {
        return loadingMain
      }
    },
    [theme]
  )

  if (!open) return false

  return (
    <div className={classes.container} style={style}>
      <img
        className={classes.imageLoader}
        src={loaderType === 'emptylawyer' ? emptylawyer : getImages(loaderType)}
        alt="Call A Lawyer"
      />
      {description}
    </div>
  )
}

export default MainLoader
